module.exports = __webpack_public_path__ + "static/hustawki-c42ee36ccc0488c64fd564f72f1ff3e0.jpg";